import React, {Fragment, useEffect, useState} from 'react';
import { Grid, GridColumn, GridRow, Input, Button, Checkbox } from "semantic-ui-react";
import {Link, useNavigate} from "react-router-dom";
import { useAppDispatch } from "../../../hooks/hooks";
import { SS_TOKEN } from "../../../common/constants/storages";
import SDCLogo from '../../../img/SDCLogo.png'
import banner from "../../../img/mainBanner.png"
import CountryDropdown from '../../../components/CountryDropdown/CountryDropdown';
import './Registration.scss';
import styles from "./Registration.module.scss"
import { IRegistrationRequest } from '../Auth.interfaces';
import { postRegistration } from "../Auth.thunk";
import HomeTopButtons from "../../../components/Buttons/HomeTopButtons/HomeTopButtons";
import Language from '../../../helpers/Language.helper';
import * as Email from "../../../helpers/email.helper";
import * as Routes from '../../../common/routes';

/*
https://stackoverflow.com/questions/62562103/dynamic-implementation-of-semantic-ui-flag-element-in-my-language-dropdown
https://react.semantic-ui.com/modules/dropdown/#types-search-in-menu
*/

const Registration: React.FC = () => {
    const [email, setEmail] = useState<string>('');
    const [emailValid, validEmail] = useState<boolean>(true);
    const [name, setName] = useState<string>('');
    const [surname, setSurname] = useState<string>('');
    const [country, setCountry] = useState<string>(Language);
    const [is2FA, setIs2FA] = useState(false);
    const dispatch = useAppDispatch();
    const navigate = useNavigate()

    useEffect(() => {
        checkIsAuthUser()
    }, [dispatch]);

    const changeEmail = (event: any) => {
        setEmail(event.target.value);
        validEmail(Email.Validate(event.target.value));
    };

    const changeName = (event: any) => {
        setName(event.target.value)
    };

    const changeSurname = (event: any) => {
        setSurname(event.target.value)
    };

    const changeIs2FA = (event: any, data: any) => {
        setIs2FA(data.checked)
    };

    const changeCountry = (event: any, data:any) => {
        setCountry(data.value)
    };

    const onEnter = (event: React.KeyboardEvent<HTMLDivElement>): void => {
        if (event.key !== 'Enter' || !emailValid || !name || !surname) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        dispatch(onRegistration);
    };

    const checkIsAuthUser = () => {
        const token = sessionStorage.getItem(SS_TOKEN);
        if (token) {
            navigate(Routes.REGISTRATION)
        }

    }
    const onRegistration = () => {
        let payload: IRegistrationRequest = {
            email: email,
            name: name,
            surname: surname,
            country: country,
            is2FA: is2FA
        }
        console.log("onRegistration payload: ", payload);
        dispatch(postRegistration(payload));
        navigate(Routes.PASSWORD)
    };

    return (
        <Fragment>
            <div className="register-container" onKeyDown={onEnter}>
                <div className={styles.banner}>
                    <div className={styles.overlay}></div>
                    <img src={banner} alt=""/>
                    <img src={banner} alt=""/>
                </div>
                <div className="register-form">
                    <div className="left">
                        <Input type="email" autoComplete="email" placeholder='Email' onChange={changeEmail} className="inputs" loading={!emailValid && (email.trim() !== "")} />
                        <Input type="text" autoComplete="name" placeholder='Name' onChange={changeName} className="inputs" />
                        <Input type="text" autoComplete="name" placeholder='Surname' onChange={changeSurname} className="inputs" />
                        <div className="inputs">
                            <CountryDropdown selected={country} placeholder="Select Country" onChange={changeCountry} />
                        </div>
                        <div className="inputs">
                            <Checkbox toggle label={{ children: 'use two-factor authentication' }} checked={is2FA} onChange={changeIs2FA} className='checkbox' />
                        </div>
                        <Button content='Register' secondary onClick={() => onRegistration()} className="register-btn" disabled={!emailValid || !name || !surname} />
                        <Grid columns={2}>
                            <GridRow style={{ padding:'40px'}}>
                                <GridColumn>
                                    <Button circular icon='google' />
                                </GridColumn>
                                <GridColumn>
                                    <Button circular icon='apple' />
                                </GridColumn>
                            </GridRow>
                        </Grid>
                        <div className="link">
                            <Link to={"/login"}>Back to Login</Link>
                        </div>
                    </div>
                    <div className="right">
                        <div className="logo">
                            <img className="logo-img" src={SDCLogo} alt="logo"/>
                        </div>
                        <span className="logo-label">Sport Data Collection</span>
                        <div className="version">office@sportdatacollection.com</div>
                    </div>
                </div>
            </div>
            <HomeTopButtons />
        </Fragment>
    )
}

export default Registration;
Registration.displayName = "Registration";